// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1nA5Q","alertIcon":"ConfirmModal_alertIcon__1CJkA"};